import styled from "@emotion/styled";
import React from "react";

const ToggleTrack = styled.span`
  label: ToggleTrack;
  position: relative;
  width: 44px;
  height: 26px;
  border-radius: 13px;
  background: #d1d1d6;
  flex-shrink: 0;
  transition: background 0.2s ease;

  &[data-toggled="true"] {
    background: linear-gradient(
      135deg,
      var(--color-sunrise-blue, #6ab4f7) 0%,
      var(--color-sunrise-pink, #c89aee) 50%,
      var(--color-sunrise-orange, #f0a472) 100%
    );
  }
`;

const ToggleThumb = styled.span`
  label: ToggleThumb;
  position: absolute;
  top: 2px;
  left: 2px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s ease;

  [data-toggled="true"] > & {
    transform: translateX(18px);
  }
`;

interface ToggleVisualProps {
  isSelected: boolean;
}

export function ToggleVisual({ isSelected }: ToggleVisualProps) {
  return (
    <ToggleTrack data-toggled={isSelected ? "true" : "false"}>
      <ToggleThumb />
    </ToggleTrack>
  );
}
